// extracted by mini-css-extract-plugin
export var actions = "_4d-0";
export var actionsContainer = "_4d-6";
export var border = "_4d-1";
export var childFullHeight = "_4d-d";
export var collapse = "_4d-2";
export var content = "_4d-8";
export var contentChild = "_4d-c";
export var fullscreen = "_4d-a";
export var headerContainer = "_4d-3";
export var headerRow = "_4d-5";
export var hidePadding = "_4d-9";
export var noScrollX = "_4d-e";
export var noScrollY = "_4d-f";
export var optOutTopPadding = "_4d-b";
export var pagePadding = "_4d-7";
export var profile = "_4d-g";
export var profileContainer = "_4d-h";
export var profileImage = "_4d-i";
export var profileMain = "_4d-j";
export var profileSubtitle = "_4d-l";
export var profileTitle = "_4d-k";
export var tabsWrapper = "_4d-4";
export var title = "_4d-m";